/*
 *###############################################################################
 *Module Name                   : LocationMasterController.js                  #
 *Purpose of the Module         : Perform Api calls                            #
 *Description of the Module     :                                              #
 *Original Author               : Chathura Prabashwara                         #
 *Date                          : Thursday , Octomber 7th 2021, 2:30:07 pm     #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                          #
 *###############################################################################
 */
const getLocationMaster = async (id) => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = [];
  var requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: 'follow'
  };
  await fetch(`${ApiURL}Locations/SearchCode/${id}`, requestOptions)
    .then(response => response.json())
    .then(result => {

      data = result.data;
    })
    .catch(error => console.log('error', error));
  return data;
}


const setLocationMaster = async (
  Active,
  WebActive,
  RemoteActive,
  StockActive,
  IsCafe,
  IsCompete,
  IsLiquor,
  IsExtLiq,
  Code,
  Desc,
  LocComCode,
  LoccosCode,
  LoclinkCode,
  LocAbrCode,
  LocGrade,
  LocGroup,
  LocSubGroup,
  LocIp,
  LocMap,
  LocFloor,
  LocOther,
  LocTotal,
  LocStaff,
  LocPosUnits,
  LocParkSlots,
  LocBkUnits,
  LocMobUnits,
  LocOpDate,
  LocClDate,
  LocOpFrom,
  LocOpTo,
  LocGrowth,
  LocCurCode,
  LocAdd,
  LocAdd2,
  LocAdd3,
  LocOPMNG,
  LocMNG,
  LocMobile1,
  LocMobile2,
  LocPhone1,
  LocPhone2,
  LocFax,
  LocEmail,
  LocMainLoc,
  LocPrmod,
  LocCity,
  LocArea,
  LocDistrict,
  LocProv,
  LocCountry,
  addNew,
  menuCode,
  LogCompanyCode,
  LocationCode,
  Reason,
  LogUserType,
  Rentals,
) => {
  const authToken = localStorage.getItem("authToken")
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);

  var raw = JSON.stringify({
    "IsActive": Active,
    "IsWebLoc": WebActive,
    "IsRemoteLoc": RemoteActive,
    "IsStock": StockActive,
    "intCafe": IsCafe,
    "intCompte": IsCompete,
    "intLiquor": IsLiquor,
    "intExtraLiquor": IsExtLiq,
    "strLocCode": Code,
    "strLocDesc": Desc,
    "strCompany": LocComCode,
    "strConCode": LoccosCode,
    "strLinkCode": LoclinkCode,
    "strAbrCode": LocAbrCode,
    "strGrade": LocGrade,
    "strGroup": LocGroup,
    "strSubGroup": LocSubGroup,
    "strLocIp": LocIp,
    "strMap": LocMap,
    "decFlore": parseFloat(LocFloor),
    "decOtherFl": parseInt(LocOther),
    "decTotArea": parseInt(LocTotal),
    "decStaff": parseFloat(LocStaff),
    "decPosUnits": parseInt(LocPosUnits),
    "decParkLots": parseInt(LocParkSlots),
    "decBkUnits": parseInt(LocBkUnits),
    "decMobUnits": parseInt(LocMobUnits),
    "dtOpDate": LocOpDate == "" ? "1900-01-01" : LocOpDate,
    "dtClDate": LocClDate == "" ? "1900-01-01" : LocClDate,
    "dtOpfromDate": '1900-01-01T' + (LocOpFrom == "" ? "00:00:00" : LocOpFrom),
    "dtOpTodate": '1900-01-01T' + (LocOpTo == "" ? "00:00:00" : LocOpTo),
    "decGrowth": parseInt(LocGrowth),
    "strCurCode": LocCurCode,
    "strAddress1": LocAdd,
    "strAddress2": LocAdd2,
    "strAddress3": LocAdd3,
    "strOpmng": LocOPMNG,
    "strMng": LocMNG,
    "strMobile1": LocMobile1,
    "strMobile2": LocMobile2,
    "strPhone1": LocPhone1,
    "strPhone2": LocPhone2,
    "strFax": LocFax,
    "strEmail": LocEmail,
    "strMAINLoc": LocMainLoc,
    "strPRMode": LocPrmod,
    "strTown": LocCity,
    "strArea": LocArea,
    "strDistrict": LocDistrict,
    "strProvide": LocProv,
    "strCountry": LocCountry,
    "blAddNew": addNew,
    "strMenuCode": menuCode,
    "strLoggedCompany": LogCompanyCode,
    "strLoggedLocation": LocationCode,
    "strReason": Reason,
    "strCreateBy": LogUserType,
    "LocationRentals": Rentals
  });

  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  var data = [];
  await fetch(`${ApiURL}Locations`, requestOptions)
    .then(response => data = response)
    .catch(error => console.log('error', error))
  return data;
}

const getCompanyMaster = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Company/Select/`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getLocationDetails = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Locations/select/`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

// location group
const getLocationGroup = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}common/LocationGroup/`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

// location sub group
const getLocationSubGroup = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}common/SubLocationGroup/`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}




//PriceMode
const getPriceModDetails = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}PriceMode/select/`, requestOptions)
    .then(response => response.json())
    .then(result => {

      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
const getGradeDetails = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}common/grade/`, requestOptions)
    .then(response => response.json())
    .then(result => {

      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getCurrencyDetails = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}common/Currency/`, requestOptions)
    .then(response => response.json())
    .then(result => {

      data = result.data
    })
    .catch(error => console.log("error", error))
  return data

}
const getcostCodeDetails = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}common/CostCode/`, requestOptions)
    .then(response => response.json())
    .then(result => {

      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

//Rentals
const loadRentals = async () => {
  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");

  //call backend and load the current stoles
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }

  await fetch(`${ApiURL}Locations/load_rentals/00001`, requestOptions)
    .then(response => response.json())
    .then(response => {
      console.log("Load Rentals", response);
    })
    .catch(error => console.log("error", error));

  const rentals = [
    { LR_CODE: 1, LR_DESC: 'Revlon', LR_SQFT: '35.50', LR_STATUS: true },
    { LR_CODE: 2, LR_DESC: 'Commercial Bank', LR_SQFT: '70.05', LR_STATUS: true },
    { LR_CODE: 3, LR_DESC: 'Renuka Products', LR_SQFT: '25.30', LR_STATUS: false },
    { LR_CODE: 4, LR_DESC: 'Christmas Stole', LR_SQFT: '52.45', LR_STATUS: true },
    { LR_CODE: 5, LR_DESC: 'Awrudu Kewili', LR_SQFT: '12.85', LR_STATUS: false },
  ]
  return rentals;
}

const saveRentals = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
}

// ********Delete button function API */
export const DeleteLocationMasterDetails = async (rowDelete) => {
  try {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    const requestOptions = {

      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify(rowDelete)

    };

    const response = await fetch(`${ApiURL}Common/Delete`, requestOptions);
    const responseData = await response.json();

    if (response.status == "200") {
      if (responseData.data == "Cannot Delete, Record Already Used!") {
        return { success: false, data: responseData.data };

      } else {
        return { success: true, data: responseData.data }
      }
    } else {
      return { success: false, data: responseData.data };
    }
  } catch (error) {
    console.error("DeleteLocationMasterDetails error:", error);
  }
};

// ********End of Delete button function API */

// *** Get and Set values when user search code function API*/
export const LocationMasterDetailsGetData = async (id) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {

      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'

    };
    const response = await fetch(`${ApiURL}Locations/SearchCode/${id}`, requestOptions);
    const responseData = await response.json();

    if (response.status == "200") {
      if (responseData.success && responseData.data.length) {
        return { success: true, data: responseData.data };
      } else {
        return { success: false, data: {} };
      }
    } else {
      return { success: false, data: {} };
    }

  } catch (error) {
    console.error("Error fetching data:", error);
    return { success: false, data: {} };
  }
}

// *** End of Get and Set values when user search code function API*/




export {
  getLocationMaster,
  setLocationMaster,
  getCompanyMaster,
  getLocationDetails,
  getPriceModDetails,
  getGradeDetails,
  getLocationGroup,
  getLocationSubGroup,
  getCurrencyDetails,
  getcostCodeDetails,
  loadRentals,
  saveRentals,
}





